import { useState } from 'react';
import { Ico } from './ui/Icons';
import dubThumb from '../assets/home/dubbing-thumb.jpg';

const DISMISS_KEY = 'l2i_dub_banner_dismissed';

export default function DubbingBanner({ onTry }) {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* ignore */ }
    setDismissed(true);
  };

  return (
    <>
      <style>{`
        .l2i-dub-banner { display: flex; align-items: center; gap: 14px; flex-wrap: nowrap; }
        .l2i-dub-copy { flex: 1; min-width: 0; }
        .l2i-dub-desc { display: block; }
        .l2i-dub-actions { flex-shrink: 0; display: flex; align-items: center; gap: 4px; }
        @media (max-width: 640px) {
          .l2i-dub-banner { flex-wrap: wrap; }
          .l2i-dub-thumb { display: none; }
          .l2i-dub-copy { flex-basis: 100%; order: 1; }
          .l2i-dub-desc { display: none; }
          .l2i-dub-actions { order: 2; flex-basis: 100%; justify-content: space-between; }
          .l2i-dub-try { flex: 1; justify-content: center; }
        }
      `}</style>
      <div className="l2i-dub-banner" style={{
        position: 'relative',
        background: 'linear-gradient(95deg,#312E81 0%,#5B21B6 50%,#9333EA 100%)',
        borderRadius: 14, padding: '14px 18px', marginBottom: 22,
        boxShadow: '0 1px 3px rgba(67,56,202,.18)',
      }}>
        {/* Thumbnail */}
        <div className="l2i-dub-thumb" style={{
          flexShrink: 0, width: 56, height: 56, borderRadius: 10, overflow: 'hidden',
          background: 'rgba(255,255,255,.08)', border: '1px solid rgba(255,255,255,.18)', position: 'relative',
        }}>
          <img src={dubThumb} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(49,46,129,0) 60%, rgba(49,46,129,.5) 100%)' }} />
          <svg style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}
            width={16} height={16} viewBox="0 0 24 24" fill="white">
            <path d="M6 4l14 8-14 8V4z" />
          </svg>
        </div>

        {/* Copy */}
        <div className="l2i-dub-copy">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
            <span style={{ padding: '2px 7px', borderRadius: 999, background: 'rgba(255,255,255,.18)', color: '#fff', fontSize: 9.5, fontWeight: 800, letterSpacing: '.08em', border: '1px solid rgba(255,255,255,.28)' }}>NEW</span>
            <span style={{ fontSize: 11.5, color: 'rgba(255,255,255,.65)', fontWeight: 600 }}>Dubbing</span>
          </div>
          <div style={{ fontSize: 14.5, fontWeight: 700, color: '#fff', letterSpacing: '-.005em', lineHeight: 1.3 }}>
            Dubbing is here — translate any video into 30+ languages.
          </div>
          <div className="l2i-dub-desc" style={{ fontSize: 12.5, color: 'rgba(255,255,255,.72)', marginTop: 2 }}>
            Upload a clip, pick a target language, keep the original voice.
          </div>
        </div>

        {/* Actions */}
        <div className="l2i-dub-actions">
          <button onClick={onTry} className="l2i-dub-try"
            style={{ flexShrink: 0, padding: '9px 16px', background: '#fff', color: '#312E81', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }}>
            Try Dubbing <Ico n="chevR" size={12} color="#312E81" />
          </button>
          <button onClick={dismiss} aria-label="Dismiss"
            style={{ flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer', padding: 6, display: 'flex' }}>
            <Ico n="x" size={14} color="rgba(255,255,255,.7)" />
          </button>
        </div>
      </div>
    </>
  );
}
